import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import CalendarToday from "@material-ui/icons/CalendarToday";
import { dateformat } from "../../../../../utils/dateFormat";
import { useDetailsInfoStyles } from "./styles";
import Grid from "@material-ui/core/Grid";
import CancellationReason from "./components/cancellation-reason";
import { Cancellation } from "../../../../../@types/cancellation";
import Person from "@material-ui/icons/Person";
import Avatar from "@material-ui/core/Avatar/Avatar";

type DetailsInfoProps = {
    cancellation: Cancellation;
};

export default function DetailsInfo({ cancellation }: DetailsInfoProps) {
    const { classes } = useDetailsInfoStyles();

    return (
        <Paper elevation={3}>
            <Box className={classes.head}>
                <Box className={classes.container}>
                    <Box className={classes.header}>
                        <Typography className={classes.title}>
                            {cancellation?.titulo}
                        </Typography>
                        <Box
                            className={`${classes.badge} ${cancellation?.ativo
                                ? classes.active
                                : classes.inactive
                                }`}
                            >
                            {cancellation?.ativo ? "Ativo" : "Inativo"}
                        </Box>
                    </Box>
                    <Box className={classes.infosContainer}>
                        <Box className={classes.infoContainer}>
                            <CalendarToday className={classes.icons} />
                            <Typography className={classes.infoContainerText}>
                                Adicionado: {dateformat(cancellation?.created_at, true)}
                            </Typography>
                        </Box>
                        <Box className={classes.infoContainer}>
                            <CalendarToday className={classes.icons} />
                            <Typography className={classes.infoContainerText}>
                                Atualizado em: {dateformat(cancellation?.updated_at, true)}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Divider />
            <Box className={classes.content}>
                <Typography className={classes.subtitle}>
                    Informações do cancelamento
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Criado por
                        </Typography>
                        <Box display="flex" alignItems="center">
                            <Avatar
                                style={{
                                width: 24,
                                height: 24,
                                marginRight: 8,
                                }}
                            >
                                <Person style={{ color: "#fff", width: 18, height: 18 }} />
                            </Avatar>
                            {cancellation?.user?.first_name}{" "}
                            {cancellation?.user?.last_name}
                        </Box>
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Reagendamento Presencial
                        </Typography>
                        <Box
                            className={`${classes.badge} ${cancellation?.reagendar_presencial
                                ? classes.active
                                : classes.inactive
                                }`}
                            >
                            {cancellation?.reagendar_presencial ? "Sim" : "Não"}
                        </Box>
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            unidade
                        </Typography>
                        <Typography className={classes.totemInfoText}>
                            {cancellation?.unidade?.nome || "Nenhuma unidade vinculada."}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Atendimento Presencial
                        </Typography>
                        <Box
                            className={`${classes.badge} ${cancellation?.presencial
                                ? classes.active
                                : classes.inactive
                                }`}
                            >
                            {cancellation?.presencial ? "Sim" : "Não"}
                        </Box>
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Motivo
                        </Typography>
                        <CancellationReason cancellation={cancellation} />
                    </Grid>
                    <Grid item xs={6} className={classes.totemInfoContainer}>
                        <Typography className={classes.totemInfoTitle}>
                            Atendimento Online
                        </Typography>
                        <Box
                            className={`${classes.badge} ${cancellation?.online
                                ? classes.active
                                : classes.inactive
                                }`}
                            >
                            {cancellation?.online ? "Sim" : "Não"}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
}
